import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuthService } from '../Auth/auth.service';
import { ConfigStrings, ErrorCodes, MediaTree } from 'src/app/utils/common-classes';

@Injectable({
  providedIn: 'root'
})
export class TreeService {

  constructor(private httpClient: HttpClient, private authService: AuthService) { }

  public getTrees(): Promise<Array<MediaTree>> {
    let _self = this;
    return new Promise((resolve, reject) => {
      const headers = _self.authService.getHeaders();
      _self.httpClient.get(ConfigStrings.API_URL + "/get-trees", { headers: headers }).subscribe((data: Array<MediaTree>) => {
        if (data) {
          resolve(data);
        } else {
          reject(new Error(ErrorCodes.UNKNOWN_ERROR));
        }
      }, (error: any) => {
        reject(error);
      });
    });
  }
}
